import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";

type BadgeVariant = "check" | "report";

interface ActionReportBadgeProps {
  variant: BadgeVariant;
  size?: number;
  /** Override tooltip (e.g. for legend) */
  title?: string;
}

const wrapperStyle = {
  display: "inline-flex" as const,
  alignItems: "center" as const,
  flexShrink: 0,
};

/**
 * Two badges for action reports (no circle, icon-only like Google event emoji):
 * - variant="check": ✓ when hasActionReport (סיום פגישה)
 * - variant="report": document icon when hasTherapistAnswered (דוח פעולה)
 */
const ActionReportBadge: React.FC<ActionReportBadgeProps> = ({
  variant,
  size = 14,
  title: titleOverride,
}) => {
  const defaultTitle =
    variant === "check"
      ? t("APPOINTMENTS_ICON_LEGEND_SAVE") || "שמירת פגישה"
      : t("APPOINTMENTS_ICON_LEGEND_REPORT") || "קיים דוח";
  const title = titleOverride ?? defaultTitle;

  return (
    <span title={title} style={{ ...wrapperStyle, color: "#10B981" }}>
      {variant === "check" ? (
        <span
          style={{ fontSize: `${size}px`, fontWeight: "bold", lineHeight: 1 }}
        >
          ✓
        </span>
      ) : (
        <svg
          viewBox="0 0 16 16"
          width={size}
          height={size}
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.5L9.5 1H4zm1 0v3.5h4V1H5zm0 5h6v1H5V6zm0 2h6v1H5V8zm0 2h4v1H5v-1z" />
        </svg>
      )}
    </span>
  );
};

export default ActionReportBadge;
